// John Eldhose 20200421
import { RestfulGet } from './Restful';

export async function getDealers() {
  const dea = await RestfulGet('getDealers', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return dea;
}



// WEBPACK FOOTER //
// ./src/Api/getDealers.js